import { render, staticRenderFns } from "./rocket.vue?vue&type=template&id=3bff988a&scoped=true&v-once=true"
import script from "./rocket.vue?vue&type=script&lang=js"
export * from "./rocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff988a",
  null
  
)

export default component.exports